export enum StateStatus {
    Open = 0,
    Acquired = 1,
    Rejected = 2,
    Pending = 3,
    Closed = 4,
    Bought = 5
}

export function getLeadStatus(status: StateStatus): string {
    switch (status) {
        case StateStatus.Bought:
            return "Erworben";
        case StateStatus.Open:
            return "Neu";
        case StateStatus.Acquired:
            return "Bestätigt";
        case StateStatus.Rejected:
            return "Abgelehnt";
        case StateStatus.Pending:
            return "Ausstehend";
        case StateStatus.Closed:
            return "Geschlossen";
        default:
            return "Unknown";
    }
}

export function getAllLeadStatus() {
    return [
        StateStatus.Bought,
        StateStatus.Open,
        StateStatus.Acquired,
        StateStatus.Rejected,
        StateStatus.Pending,
        StateStatus.Closed,
    ];
}


export function getAssignedStatus(status: StateStatus): string {
    switch (status) {
        case StateStatus.Open:
            return "Peter Meier";
        case StateStatus.Acquired:
            return "Petra Schmidt";
        case StateStatus.Rejected:
            return "Hans Schmidt";
        case StateStatus.Pending:
            return "Maria Müller";
        default:
            return "Unknown";
    }

}